// src/components/Stepper.jsx
import { useTranslation } from 'react-i18next';

export default function Stepper({ current, steps }) {
  const { t } = useTranslation();

  return (
    <ol className="flex items-center w-full mb-8">
      {steps.map((key, idx) => {
        const step = idx + 1;
        const isDone = step < current;
        const isActive = step === current;
        return (
          <li key={key} className="flex items-center flex-1 last:flex-none">
            <div
              className={`flex flex-col items-center text-center text-xs sm:text-sm ${
                isActive ? 'font-bold' : 'text-gray-500'
              }`}
            >
              <div
                className={`w-8 h-8 rounded-full flex items-center justify-center mb-1 transition ${
                  isDone
                    ? 'text-white'
                    : isActive
                    ? 'text-white'
                    : 'bg-gray-200 text-gray-500'
                }`}
                style={
                  isDone || isActive
                    ? { background: 'var(--color-primary)' }
                    : {}
                }
              >
                {isDone ? '✓' : step}
              </div>
              <span className="hidden sm:block">{t(`create.${key}`)}</span>
            </div>
            {idx < steps.length - 1 && (
              <div
                className={`flex-1 h-px mx-2 transition ${
                  step < current ? '' : 'bg-gray-200'
                }`}
                style={step < current ? { background: 'var(--color-primary)' } : {}}
              />
            )}
          </li>
        );
      })}
    </ol>
  );
}
